import { SignalR } from '@core/model/framework/notifications/signalR';
import { TaggingMetricMapper } from '@adapters/tagging/taggingMetricMapper';
import { TaggingContainer, TaggingTracker } from '@core/model/domain/taggingTracker';
import { OneyIdentifier } from '@core/model/framework/OneyIdentifier';
import { HttpClient } from '@core/model/framework/httpClient';
import { WaitOnWebauthNotificationGateway } from '@core/model/gateway/waitOnWebauthNotificationGateway';
import { BankService } from '@core/model/service/bankService';
import { AccountService } from '@core/model/service/accountService';
import { WaitOnCaseStateNotificationGateway } from '@core/model/gateway/waitOnCaseStateNotificationGateway';
import { BrowserBroadcast } from '@adapters/broadcast/browserBroadcast';
import { Logger } from '@core/model/domain/logger';

export const SERVICE_ID = {
  // Http clients
  openBankingHttpClient: OneyIdentifier<HttpClient>('openBankingHttpClient'),

  // Services
  bankService: OneyIdentifier<BankService>('bankService'),
  accountService: OneyIdentifier<AccountService>('accountService'),

  signalR: OneyIdentifier<SignalR>('signalR'),
  taggingTracker: OneyIdentifier<TaggingTracker>('taggingTracker'),
  taggingMetricMapper: OneyIdentifier<TaggingMetricMapper>('taggingMetricMapper'),
  logger: OneyIdentifier<Logger>('logger'),
  browserBroadcast: OneyIdentifier<BrowserBroadcast>('browserBroadcast'),

  // Gateways
  waitOnWebauthNotificationGateway: OneyIdentifier<WaitOnWebauthNotificationGateway>(
    'waitOnWebauthNotificationGateway'
  ),
  waitOnCaseStateNotificationGateway: OneyIdentifier<WaitOnCaseStateNotificationGateway>(
    'waitOnCaseStateNotificationGateway'
  ),

  // Constants
  waitOnWebauthTimeoutInSeconds: OneyIdentifier<number>('waitOnWebauthTimeoutInSeconds'),
  waitOnWebauthIntervalInSeconds: OneyIdentifier<number>('waitOnWebauthIntervalInSeconds'),

  waitOnCaseStateTimeoutInSeconds: OneyIdentifier<number>('waitOnCaseStateTimeoutInSeconds'),
  waitOnCaseStateIntervalInSeconds: OneyIdentifier<number>('waitOnCaseStateIntervalInSeconds'),

  taggingContainers: OneyIdentifier<Array<TaggingContainer>>('taggingContainers'),

  // Feature flag
  signalRFeatureFlag: OneyIdentifier<boolean>('signalRFeatureFlag'),
  isTrackingEnabled: OneyIdentifier<boolean>('isTrackingEnabled'),
};
